import React from 'react';
import { Delivery, DeliveryParcel, Task, Tools } from '@carbon/icons-react';
import ProgressStep from '@components/ProgressStep/ProgressStep';

interface Props {
  activeStep?: number;
  isStopped?: boolean;
}

interface Step {
  icon: React.ReactNode;
  label: string;
}

const steps: Step[] = [
  {
    icon: <Task size={16} />,
    label: '발주/결제'
  },
  {
    icon: <Tools size={16} />,
    label: '제조'
  },
  {
    icon: <Delivery size={16} />,
    label: '배송'
  },
  {
    icon: <DeliveryParcel size={16} />,
    label: '거래완료'
  }
];

/**
 * This function takes in an activeStep and isStopped prop and returns a ProgressStep component with
 * the steps, activeStep, and isStopped props
 * @param activeStep when activeStep is -1, every steps are inactivated.
 * @returns A ProgressStep component with the steps, activeStep, and isStopped props.
 */
const PurchaseOrderStepper = ({ activeStep, isStopped = false }: Props) => {
  return (
    <ProgressStep steps={steps} activeStep={activeStep} isStopped={isStopped} />
  );
};

export default PurchaseOrderStepper;
